import * as React from 'react';

const blogIconSmall = (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="4" fill="white"/>
    <rect x="1" y="1" width="8.4" height="8.4" rx="1.2" fill="url(#paint0_linear_23111_866)"/>
    <rect x="10.6001" y="1" width="8.4" height="8.4" rx="1.2" fill="url(#paint1_linear_23111_866)"/>
    <rect x="10.6001" y="10.6003" width="8.4" height="8.4" rx="1.2" fill="url(#paint2_linear_23111_866)"/>
    <rect x="1" y="10.6003" width="8.4" height="8.4" rx="1.2" fill="url(#paint3_linear_23111_866)"/>
    <rect x="11.8" y="13.0002" width="6" height="1.2" fill="url(#paint4_linear_23111_866)"/>
    <rect x="2.19995" y="4.59985" width="6" height="1.2" fill="url(#paint5_linear_23111_866)"/>
    <rect x="11.8" y="4.6001" width="6" height="1.2" fill="url(#paint6_linear_23111_866)"/>
    <rect x="2.23291" y="17.0098" width="7.08483" height="1.2" transform="rotate(-45 2.23291 17.0098)" fill="url(#paint7_linear_23111_866)"/>
    <rect x="5.80005" y="2.19995" width="6" height="1.2" transform="rotate(90 5.80005 2.19995)" fill="url(#paint8_linear_23111_866)"/>
    <rect x="11.8" y="15.4001" width="6" height="1.2" fill="url(#paint9_linear_23111_866)"/>
    <circle cx="3" cy="13" r="1" fill="url(#paint10_linear_23111_866)"/>
    <circle cx="7" cy="17" r="1" fill="url(#paint11_linear_23111_866)"/>
    <defs>
    <linearGradient id="paint0_linear_23111_866" x1="8.07778" y1="8.04119" x2="-2.31849" y2="4.19122" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_23111_866" x1="17.6779" y1="8.04119" x2="7.2816" y2="4.19122" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint2_linear_23111_866" x1="17.6779" y1="17.6415" x2="7.2816" y2="13.7916" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint3_linear_23111_866" x1="8.07778" y1="17.6415" x2="-2.31849" y2="13.7916" gradientUnits="userSpaceOnUse">
    <stop stop-color="#2744FF"/>
    <stop offset="1" stop-color="#B9D5FF"/>
    </linearGradient>
    <linearGradient id="paint4_linear_23111_866" x1="16.2118" y1="13.886" x2="15.1698" y2="10.7243" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint5_linear_23111_866" x1="6.61172" y1="5.48557" x2="5.56966" y2="2.32392" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint6_linear_23111_866" x1="16.2118" y1="5.48581" x2="15.1698" y2="2.32416" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint7_linear_23111_866" x1="7.44234" y1="17.8955" x2="6.5347" y2="14.6437" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint8_linear_23111_866" x1="10.2118" y1="3.08567" x2="9.16976" y2="-0.0759842" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint9_linear_23111_866" x1="16.2118" y1="16.2859" x2="15.1698" y2="13.1242" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint10_linear_23111_866" x1="3.47059" y1="13.4762" x2="0.879709" y2="11.904" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    <linearGradient id="paint11_linear_23111_866" x1="7.47059" y1="17.4762" x2="4.87971" y2="15.904" gradientUnits="userSpaceOnUse">
    <stop stop-color="#D6DFE9"/>
    <stop offset="1" stop-color="white"/>
    </linearGradient>
    </defs>
    </svg>    
    );

export default blogIconSmall; 
